export default __webpack_public_path__ + "static/media/white_person.a36ea8bd.svg";